import React, { useState, createContext } from 'react';

const FormContext = createContext();

export function FormProvider({ children }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [wavelyticsAnswers, setWavelyticsAnswers] = useState([]);
  const [recommendation, setRecommendation] = useState(
    'Benchmarking + Advanced Analytics + Self Serve Analytics'
  );

  const handleWavelyticsAnswers = (answer, step, activeQuiz, question) => {
    const currentStep = activeQuiz.id === 0 ? step : step + 3;

    // Special case: quiz 2, step 3 => force answer to array
    const normalizedAnswer =
      activeQuiz.id === 2 && currentStep === 3
        ? Array.isArray(answer)
          ? answer
          : [answer]
        : answer;

    setWavelyticsAnswers((prev) => {
      const existingIndex = prev.findIndex(
        (entry) => entry.step === currentStep
      );

      if (existingIndex !== -1) {
        // Step already exists – update it
        const updated = [...prev];
        updated[existingIndex] = {
          ...updated[existingIndex],
          answer: normalizedAnswer,
        };
        return updated;
      } else {
        // New step – add it
        return [
          ...prev,
          { step: currentStep, question, answer: normalizedAnswer },
        ];
      }
    });
  };

  return (
    <FormContext.Provider
      value={{
        isLoaded,
        setIsLoaded,
        wavelyticsAnswers,
        setWavelyticsAnswers,
        handleWavelyticsAnswers,
        recommendation,
        setRecommendation,
      }}
    >
      {children}
    </FormContext.Provider>
  );
}

export default FormContext;
